import { KYMW6700Component } from './kymw6700.component';

/**
 * 校正紙画面の値を管理するクラス
 *
 * @export KYMW6700Model
 * @class KYMW6700Model
 */
export class KYMW6700Model {

  KYMW6700Component: KYMW6700Component;

  // ファイル名
  public fileName: string = <string>'';

  /** 出力区分(1：バイヤー・編集) */
  public OUTPUT_DIV_BUYER:      string = <string>'1';
  /** 出力区分(3：見切り品) */
  public OUTPUT_DIV_LOGISTICS:  string = <string>'3';
  /** 見切り品媒体区分 */
  public ADMIN_DIV_LOGISTICS:   string = <string>'028';
  /** 出力区分 */
  public outputDiv:       string = <string>'';
  /** 受注コード */
  public orderCode:       string = <string>'';
  /** 媒体区分 */
  public mediumType:      string = <string>'';
  /** 工程管理NO */
  public progressWorkNum: string = <string>'';
  /** 部門コード */
  public classCode:       string = <string>'';
  /** バイヤーコード */
  public buyerCode:       string = <string>'';

  /** 媒体活性非活性判定 */
  public disabledMediumToFlg: boolean = <boolean> false;
  /** フェーズ活性非活性判定 */
  public disabledPhaseToFlg:  boolean = <boolean> false;
  /** バイヤー活性非活性判定 */
  public disabledBuyerToFlg:  boolean = <boolean> false;


  public pCodeList: string = <string>'';

  /**
   * ファイル名を更新する
   *
   * @param serverData ファイル名のサーバ取得データ
   */
  public updateFileName(serverData: any) {
    this.fileName = serverData.FileName;
  }
}
